// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2a3sU","itemPic":"index_itemPic_3IOg_"};